import { Observable } from 'rxjs';
import { InstalacionDireccion } from '../interfaces/instalacion-direccion';


export abstract class InstalacionDireccionService {

    abstract obtenerDireccionInstalacion(): Observable<InstalacionDireccion> ;

    abstract actualizarDireccionInstalacion(direccion: InstalacionDireccion): Observable<any>;
}
